// extracted by mini-css-extract-plugin
export default {"heading":"shared-section_heading__sIfjs","row":"shared-section_row__9vZlo","col":"shared-section_col__r1vPb","not-important":"shared-section_not-important__bqImi"};